module.exports = __webpack_public_path__ + "static/media/Kenee Walton_1617809903324.1552457d.jpg";